// Centralized frontend config for session management and token refresh
export const ACCESS_TOKEN_TTL = parseInt(
  process.env.REACT_APP_ACCESS_TOKEN_TTL || "18000",
  10
);
export const REFRESH_TOKEN_TTL = parseInt(
  process.env.REACT_APP_REFRESH_TOKEN_TTL || "43200",
  10
);

export const COUNTDOWN_DURATION_MINUTES = parseInt(
  process.env.REACT_APP_COUNTDOWN_DURATION_MINUTES || "30",
  10
);
export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";
